var map = {
	"./BirreArtigW280.png": 97579,
	"./CavatappiW280.png": 88627,
	"./CaveFrigoW280.png": 36218,
	"./DistillatiW280.png": 5367,
	"./PromoW280.png": 74705,
	"./offerteW280.png": 86035,
	"./regionaleW280.png": 76640,
	"./scatolaSpumanteW280.png": 89730,
	"./scatolaVinox4W280.png": 49415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18427;